<template>
    <div class="payment-callback">
        <processing></processing>
        <h4>{{ $t('payment_processing.title') }}</h4>
        <p>{{ $t('payment_processing.des') }}</p>
        <div v-if="showButton">
            <a :href="appUrl" class="ui-button primary-button back-to-app">{{ $t('payment_processing.back_to_app') }}</a>
            <p class="app-note">{{ $t('payment_processing.app_note') }}</p>
        </div>
    </div>
</template>

<script>
import processing from '@/basic/processing';
import { approval, cancelPayment, queryPaymentResult } from '@/api/cart';
import { payment as paymentStatus } from '@/config/status';
import { setTimeout, clearTimeout } from 'timers';
import router from '@/router';
import { unfoldError } from '@/common/js/notice';
import { config } from 'CONFIG';
import { getQueryField } from '@/common/js/utils';
import reolinkGa from '@/common/js/gtagPageview';

export default {

    components: {

        processing

    },

    data () {

        return {

            status: 'waiting',
            timer: null,
            planId: 0,
            redirectLink: '',
            paymentStatus,
            result: this.$route.query['r-cloud-result'],
            id: this.$route.query['r-cloud-id'],
            paymentMethodId: this.$route.query['r-cloud-paymentMethod'],
            querystring: window.location.search.slice( 1 ),
            interval: 0,
            appUrl: '',
            showButton: false,
            client: 'Web'

        };

    },

    async created () {

        let suc = await this._approval();
        if ( suc ) {

            this.statusHandle();

        }

    },
    methods: {

        async _approval () {

            try {
                
                if ( this.result === 'ok' ) {
        
                    let approvalRes = await approval( this.paymentMethodId, this.querystring );
                    let {status, items} = approvalRes;
                    this.planId = items[ 0 ].id;
                    this.status = status;

                } else {

                    /**
                     * url中query.result不是ok
                     * 
                     * 即用户在paypal点击了取消
                     */

                    this.status = paymentStatus.CANCELLED;

                }
                reolinkGa.sendEvent( 'Payment proccessing success', this.id );
                return true;

            } catch ( err ) {

                console.error( err );
                let result = await queryPaymentResult( this.id );
                let { redirectLink } = result;
                // 如果是app跳转出来支付的，则切回app
                if ( !redirectLink.includes( '/checkout/payment-complete/' )) {

                    window.location = redirectLink;
                    this.appUrl = redirectLink;
                    this.showButton = true;

                } else {

                    let symbol;
                    let code;
                    if ( err && err.response && err.response.data && err.response.data.error ) {

                        symbol = err.response.data.error.symbol;
                        code = err.response.data.error.code;

                    }

                    let errorSymbol = symbol || 'server_error';
                    reolinkGa.sendEvent( 'Payment proccessing error', `${errorSymbol} on ${this.id}` );

                    if ( code === 53269 ) {
    
                        unfoldError( 'errors.frequent_confirm_payment' );
                        this.timer = setTimeout(() => {
    
                            router.push( '/user/dashboard/' );
    
                        }, 5000 );
    
                    } else if ( code === 53268 ) {
    
                        router.push({
    
                            path: '/checkout/payment-complete/',
        
                            query: {
        
                                id: this.id,
                                platform: 'web'
        
                            }
        
                        });
    
                    } else {
    
                        unfoldError( 'errors.server_error', 9999999 );
    
                    }

                }

                return false;

            }

        },
        async statusHandle () {

            console.log( 'status handle' );
            let timeout = 0;
            /**
             * 订单状态为确认中时
             * 
             * 继续确认订单状态
             */
            if ( this.status === paymentStatus.PROCESSING || this.status === paymentStatus.PENDING ) {

                this.queryResult();

            } else if ( this.status === paymentStatus.CANCELLED ) {

                /**
                 * 取消订单
                 */

                let { redirectLink } = await cancelPayment( this.id );
                this.timer = setTimeout(() => {

                    /**
                     * 如果返回的跳转地址（创建支付时传递过来的）不是order-complete页面
                     * 
                     * 则返回app
                     * 
                     * 否则浏览器跳转到order-complete页面
                     */
                    if ( !redirectLink.includes( '/checkout/payment-complete/' )) {

                        window.location = redirectLink;
                        this.appUrl = redirectLink;
                        this.showButton = true;

                    } else {

                        router.push({

                            path: '/checkout/payment-complete/',
    
                            query: {
    
                                id: this.id,
                                platform: config.platform,
                                mode: getQueryField( redirectLink ).mode,
                                prevPlan: getQueryField( redirectLink ).prevPlan
    
                            }
    
                        });

                    }

                }, timeout );

            } else {

                /**
                 * 其他情况
                 * 
                 * 直接跳转到complete页面
                 */
                
                if ( !this.redirectLink.includes( '/checkout/payment-complete/' )) {

                    window.location = this.redirectLink;
                    this.appUrl = this.redirectLink;
                    this.showButton = true;

                } else {

                    router.push({

                        path: '/checkout/payment-complete/',
    
                        query: {
    
                            id: this.id,
                            platform: 'web',
                            mode: getQueryField( this.redirectLink ).mode,
                            prevPlan: getQueryField( this.redirectLink ).prevPlan
    
                        }
    
                    });
                    
                }

            }

        },
        _setTimeout ( url, second ) {

            this.timer = setTimeout(() => {

                router.push( url );

            }, second );

        },
        async queryResult () {

            /**
             * 第一次间隔2s
             * 
             * 第二次间隔5s
             * 
             * 之后每次间隔30s
             */

            console.log( 'query result' );
            if ( this.interval === 0 ) {

                this.interval = 2000;

            } else if ( this.interval === 2000 ) {

                this.interval = 5000;

            } else {

                this.interval = 30000;

            }
            this.timer = setTimeout( async () => {
                
                try {
                    
                    let result = await queryPaymentResult( this.id );
                    this.status = result.status;
                    this.redirectLink = result.redirectLink;

                } catch ( err ) {

                    unfoldError( 'errors.server_error' );

                }
                this.statusHandle();

            }, this.interval );

        }

    },
    destroyed () {
        
        clearTimeout( this.timer );

    }

};
</script>

<style lang="less" scoped>
.payment-callback{
    padding: 1.6rem 15px;
    text-align: center;
}
h4{
    font-size: 0.36rem;
    margin-bottom: 0.1rem;
    margin-top: 0.2rem;
    text-align: center;
    @media @mobile{
        font-size: 0.46rem;
    }
}
p{
    font-size: 0.18rem;
    @media @mobile{
        font-size: 0.32rem;
    }
    &.app-note{
        font-size: 0.16rem;
        margin-top: 0.3rem;
        @media @mobile{
            font-size: 0.26rem;
        }
    }
}
i{
    color: @theme;
    font-size: 0.6rem;
    &.wrong{
        color: #777;
    }
}
.back-to-app{
    margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/view/callback/payment.vue